export default __webpack_public_path__ + "static/document_placeholder-e0b3d9c03c738a0940b39dd9125ae662.png";